import { useMenuSidebar } from 'contexts/MenuSidebarContext';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  deleteMenuAberto,
  deleteTelaAberta,
  getEtapaSessionCapitalFlow,
  setEtapaSessionCapitalFlow
} from 'services/authentication/auth';

const useCapitalFlowHook = ({ escopoAcesso, setEscopoAcesso }) => {
  const [carregarTela, setCarregarTela] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const navigate = useNavigate();
  const { esconderMenuPrincipal } = useMenuSidebar();
  const etapaCapitalFlow = getEtapaSessionCapitalFlow();

  useEffect(() => {
    if (!escopoAcesso?.plataforma_oneshell?.componente['jornada-capital-flow']) {
      navigate('/home');
    }

    deleteMenuAberto();
    deleteTelaAberta();
    esconderMenuPrincipal();
    setCarregarTela(etapaCapitalFlow ?? 'NovaCessao');
  }, []);

  useEffect(() => {
    setEtapaSessionCapitalFlow(carregarTela);
  }, [carregarTela]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  return {
    setCarregarTela,
    carregarTela,
    handleClose,
    openAlert
  };
};

export default useCapitalFlowHook;
